
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 11 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.74 14H1.98c-1.09 0-1.99-.9-1.99-2V2c0-1.1.9-2 1.99-2h3.9C7.34 0 8.5.64 9.25 1.79c.81 1.24.87 2.83.16 4.15-.14.27-.15.51-.35.73 1 .65 1.71 1.7 1.83 2.9.11 1.15-.24 2.24-.98 3.07C9.13 13.5 7.97 14 6.74 14zM1.98 8v4h4.98c.67 0 2 .06 2-2 0-1.94-.9-2-2-2H1.98zm0-2h3.99c.62 0 1.99 0 1.99-2 0-1.94-1.21-2-1.99-2H1.98v4z"}})])
          )
        }
      }
    